export const GET_CURRENT_SHARED_EXPERIENCE = "GET_CURRENT_SHARED_EXPERIENCE";
export const REFRESH_CURRENT_SHARED_EXPERIENCE = "REFRESH_CURRENT_SHARED_EXPERIENCE";
export const RESET_CURRENT_SHARED_EXPERIENCE = "RESET_CURRENT_SHARED_EXPERIENCE";
export const SET_CURRENT_SHARED_EXPERIENCE_REQUEST_STATUS = "SET_CURRENT_SHARED_EXPERIENCE_REQUEST_STATUS";
